import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxLabelHelper {
  public static getTenorLabel(tenor: CubiqTS.Tenor): string {
    switch (tenor) {
      case CubiqTS.Tenor.TDY:
        return "TDY";
      case CubiqTS.Tenor.TOM:
        return "TOM";
      case CubiqTS.Tenor.SPOT:
        return "SP";
      case CubiqTS.Tenor.W1:
        return "1W";
      case CubiqTS.Tenor.W2:
        return "2W";
      case CubiqTS.Tenor.W3:
        return "3W";
      case CubiqTS.Tenor.M1:
        return "1M";
      case CubiqTS.Tenor.M2:
        return "2M";
      case CubiqTS.Tenor.M3:
        return "3M";
      case CubiqTS.Tenor.M4:
        return "4M";
      case CubiqTS.Tenor.M5:
        return "5M";
      case CubiqTS.Tenor.M6:
        return "6M";
      case CubiqTS.Tenor.M7:
        return "7M";
      case CubiqTS.Tenor.M8:
        return "8M";
      case CubiqTS.Tenor.M9:
        return "9M";
      case CubiqTS.Tenor.M10:
        return "10M";
      case CubiqTS.Tenor.M11:
        return "11M";
      case CubiqTS.Tenor.Y1:
        return "1Y";
      case CubiqTS.Tenor.M13:
        return "13M";
      case CubiqTS.Tenor.M14:
        return "14M";
      case CubiqTS.Tenor.M15:
        return "15M";
      case CubiqTS.Tenor.M16:
        return "16M";
      case CubiqTS.Tenor.M17:
        return "17M";
      case CubiqTS.Tenor.M18:
        return "18M";
      case CubiqTS.Tenor.M19:
        return "19M";
      case CubiqTS.Tenor.M20:
        return "20M";
      case CubiqTS.Tenor.M21:
        return "21M";
      case CubiqTS.Tenor.M22:
        return "22M";
      case CubiqTS.Tenor.M23:
        return "23M";
      case CubiqTS.Tenor.Y2:
        return "2Y";
      case CubiqTS.Tenor.Y3:
        return "3Y";
      case CubiqTS.Tenor.Y4:
        return "4Y";
      case CubiqTS.Tenor.Y5:
        return "5Y";
      case CubiqTS.Tenor.SN:
        return "SN";
      case CubiqTS.Tenor.ALL:
        return "All";
    }
    return CubiqTS.Tenor[tenor];
  }

  public static getTenorFromLabel(tenor: string): CubiqTS.Tenor {
    switch (tenor) {
      case "TDY":
        return CubiqTS.Tenor.TDY;
      case "TOM":
        return CubiqTS.Tenor.TOM;
      case "SP":
        return CubiqTS.Tenor.SPOT;
      case "1W":
        return CubiqTS.Tenor.W1;
      case "2W":
        return CubiqTS.Tenor.W2;
      case "3W":
        return CubiqTS.Tenor.W3;
      case "1M":
        return CubiqTS.Tenor.M1;
      case "2M":
        return CubiqTS.Tenor.M2;
      case "3M":
        return CubiqTS.Tenor.M3;
      case "4M":
        return CubiqTS.Tenor.M4;
      case "5M":
        return CubiqTS.Tenor.M5;
      case "6M":
        return CubiqTS.Tenor.M6;
      case "7M":
        return CubiqTS.Tenor.M7;
      case "8M":
        return CubiqTS.Tenor.M8;
      case "9M":
        return CubiqTS.Tenor.M9;
      case "10M":
        return CubiqTS.Tenor.M10;
      case "11M":
        return CubiqTS.Tenor.M11;
      case "1Y":
        return CubiqTS.Tenor.Y1;
      case "13M":
        return CubiqTS.Tenor.M13;
      case "14M":
        return CubiqTS.Tenor.M14;
      case "15M":
        return CubiqTS.Tenor.M15;
      case "16M":
        return CubiqTS.Tenor.M16;
      case "17M":
        return CubiqTS.Tenor.M17;
      case "18M":
        return CubiqTS.Tenor.M18;
      case "19M":
        return CubiqTS.Tenor.M19;
      case "20M":
        return CubiqTS.Tenor.M20;
      case "21M":
        return CubiqTS.Tenor.M21;
      case "22M":
        return CubiqTS.Tenor.M22;
      case "23M":
        return CubiqTS.Tenor.M23;
      case "2Y":
        return CubiqTS.Tenor.Y2;
      case "3Y":
        return CubiqTS.Tenor.Y3;
      case "4Y":
        return CubiqTS.Tenor.Y4;
      case "5Y":
        return CubiqTS.Tenor.Y5;
      case "SN":
        return CubiqTS.Tenor.SN;
      default:
        logger.out.warn(
          `ERROR: BfxLabelHelper.getTenorFromLabel(): Label (${tenor}) for Tenor not matched`,
        );
    }
    return CubiqTS.Tenor.ALL;
  }
}
